// extracted by mini-css-extract-plugin
export default {"menuItem":"k8_175mqdvmC7vck8y_B"};